export const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._+-]+(?:\.[a-zA-Z0-9._+-]+)*@(?:(?=[a-zA-Z0-9-]{1,63}\.)[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,62}$/;
    return emailRegex.test(email.trim());
};
//# sourceMappingURL=validateEmail.js.map